<template lang="pug">

div

    .ui.secondary.menu

        router-link.item(:to='{ name: "addresses" }' exact) Übersicht Adressen
        router-link.item(:to='{ name: "addresses/update"}' v-if="isAddressUpdateVisible()") Adresse bearbeiten
        router-link.item(:to='{ name: "addresses/create" }') Adresse anlegen

        router-link.item(:to='{ name: "persons" }' exact) Übersicht Personen
        router-link.item(:to='{ name: "persons/update"}' v-if="isPersonUpdateVisible()") Person bearbeiten
        router-link.item(:to='{ name: "persons/create" }') Person anlegen

    .ui.divider

</template>

<script>

    //noinspection JSUnusedGlobalSymbols
    export default {

        methods: {
            isAddressUpdateVisible() {
                return this.$route.name === 'addresses/update'
            },
            isPersonUpdateVisible() {
                return this.$route.name === 'persons/update'
            }
        }

    }

</script>

